// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
export type ProjectileInfo = {
  amount: number,
  speed: number,
  size: number,
  damage: number,
  spread: number,
  color: string,
  rateOfFire: number,
  lifetime: number,
};

/**
 * A namespace for generated helper functions.
 */
export namespace ProjectileInfo {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("amount", AlgebraicType.createI32Type()),
      new ProductTypeElement("speed", AlgebraicType.createI32Type()),
      new ProductTypeElement("size", AlgebraicType.createI32Type()),
      new ProductTypeElement("damage", AlgebraicType.createI32Type()),
      new ProductTypeElement("spread", AlgebraicType.createI32Type()),
      new ProductTypeElement("color", AlgebraicType.createStringType()),
      new ProductTypeElement("rateOfFire", AlgebraicType.createF32Type()),
      new ProductTypeElement("lifetime", AlgebraicType.createF32Type()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: ProjectileInfo): void {
    ProjectileInfo.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): ProjectileInfo {
    return ProjectileInfo.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


